export const SUPABASE_URL = 'https://itipjzcggtzxrjxookes.supabase.co';
export const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml0aXBqemNnZ3R6eHJqeG9va2VzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjMxNTI2MjAsImV4cCI6MjA3ODcyODYyMH0.00KNlqhfCPHfz71yBgiRytXLhWM98vLlXooJWe19jE8';

export const SUPABASE_STORAGE_ROOT =
  'https://itipjzcggtzxrjxookes.supabase.co/storage/v1/object/public/babylon/';
export const SUPABASE_VIDEOS_ROOT =
  'https://itipjzcggtzxrjxookes.supabase.co/storage/v1/object/public/babylon/videos/';
export const SUPABASE_SOUNDS_ROOT =
  'https://itipjzcggtzxrjxookes.supabase.co/storage/v1/object/public/babylon/sounds/';

// Asset subdirectories
export const ASSET_PATHS = {
  images: 'images/',
  meshes: 'meshes/',
  scenes: 'scenes/',
  sounds: 'sounds/',
  textures: 'textures/'
};

// Positions relative to user's initial AR position (forward = +Z in Babylon's left-handed system)
export const TORUS_POSITION = { x: 0, y: 0.2, z: 3 };
export const IMAGE_PLANE_POSITION = { x: 0, y: 2, z: 5 };

export const TORUS_SCALE = 0.133;

// Torus state colors (emissive)
export const TORUS_COLORS = {
  idle: { r: 0.0, g: 0.8, b: 1.0 },      // Cyan
  recording: { r: 1.0, g: 0.0, b: 0.0 }, // Red
  uploading: { r: 1.0, g: 1.0, b: 0.0 }, // Yellow
  error: { r: 0.6, g: 0.0, b: 0.8 }      // Purple
};

export const TORUS_TRANSITION_MS = 300;
export const IMAGE_PLANE_SIZE = { width: 2.25, height: 4 };
export const IMAGE_PLANE_CURVE = 0.05;
export const IMAGE_PLANE_SEGMENTS = 20;
export const FLOOR_SIZE = 20;

export const RECORD_DURATION_MS = 5000;
export const WEBHOOK_URL = 'https://holla.app.n8n.cloud/webhook/process-audio';

export const SESSION_COOKIE_NAME = 'sessionid';
export const SESSION_COOKIE_MAX_AGE = 60 * 60 * 24; // 1 day in seconds
export const AUTH_COOKIE_NAME = 'sb-auth-token';

export const BROADCAST_EVENT_NAME = 'media-ready';

// Media file type categories
export type MediaFileType = 'video' | 'audio' | 'model' | 'scene' | 'image' | 'texture';

// Storage folders to search for media files
export const STORAGE_FOLDERS = ['videos', 'sounds', 'meshes', 'scenes', 'images', 'textures'] as const;

// Map folder names to media types
export const FOLDER_TO_TYPE: Record<string, MediaFileType> = {
  videos: 'video',
  sounds: 'audio',
  meshes: 'model',
  scenes: 'scene',
  images: 'image',
  textures: 'texture',
};

// Map file extensions to media types
export const EXTENSION_TO_TYPE: Record<string, MediaFileType> = {
  '.webm': 'video',
  '.mp4': 'video',
  '.weba': 'audio',
  '.mp3': 'audio',
  '.wav': 'audio',
  '.glb': 'model',
  '.gltf': 'model',
  '.babylon': 'scene',
  '.png': 'image',
  '.jpg': 'image',
  '.jpeg': 'image',
};
